import { PanelLeftClose, PanelLeft, X } from 'lucide-react';

import type { ReactNode } from 'react';

type Props = {
  collapsed: boolean;
  onToggle: () => void;
  onMobileClose?: () => void;
};

const borderStyle = { borderColor: 'var(--border-subtle)' };
const titleStyle = { fontFamily: 'var(--font-display, Unbounded)' };
const btnStyle = { color: 'var(--text-muted)' };

function DesktopToggle({
  collapsed,
  onToggle,
}: {
  collapsed: boolean;
  onToggle: () => void;
}): ReactNode {
  const Icon = collapsed ? PanelLeft : PanelLeftClose;
  return (
    <button
      onClick={onToggle}
      style={btnStyle}
      className="hidden md:block p-2 rounded-md hover:bg-[#1A1A1A]"
      aria-label="Toggle sidebar"
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}

function MobileClose({ onClose }: { onClose: () => void }): ReactNode {
  return (
    <button
      onClick={onClose}
      style={btnStyle}
      className="p-2 md:hidden"
      aria-label="Close menu"
    >
      <X className="w-5 h-5" />
    </button>
  );
}

export function SidebarHeader({
  collapsed,
  onToggle,
  onMobileClose,
}: Props): ReactNode {
  return (
    <div
      style={borderStyle}
      className="flex items-center justify-between h-16 px-4 border-b"
    >
      {!collapsed && (
        <span
          style={titleStyle}
          className="text-sm font-semibold tracking-tight whitespace-nowrap"
        >
          Social Assistant
        </span>
      )}
      <DesktopToggle collapsed={collapsed} onToggle={onToggle} />
      {onMobileClose && <MobileClose onClose={onMobileClose} />}
    </div>
  );
}
